<script setup lang="ts">
import { twMerge } from "tailwind-merge";

import { useUser } from "@/composables/api/useUser";

const props = withDefaults(
  defineProps<{
    class?: string;
    variant?: "primary" | "secondary" | "topchef" | "outline" | "lactel";
    disabled?: boolean;
  }>(),
  { variant: "primary" },
);
const { data: user } = useUser();
</script>

<template>
  <button
    type="button"
    :disabled="props.disabled"
    :class="{
      [twMerge(
        'focus:ring-galbani/25 flex cursor-pointer items-center justify-center gap-2.5 rounded-full px-8 py-3 text-lg/tight font-medium transition-all duration-150 ease-out focus:ring-2 focus:ring-offset-0 focus:outline-none disabled:cursor-default disabled:bg-[#9B9B9B] disabled:text-white [&>svg]:size-6 [&>svg]:shrink-0 lg:[&>svg]:size-10',
        props.class,
      )]: true,
      'text-galbani border-galbani border bg-white hover:bg-white/80':
        variant === 'primary' && user?.current_mechanic !== 'lactel',
      'text-lactel-blue border-lactel-blue border bg-white hover:bg-white/80':
        variant === 'primary' && user?.current_mechanic === 'lactel',
      'bg-galbani hover:bg-galbani/80 text-white':
        variant === 'secondary' && user?.current_mechanic !== 'lactel',
      'bg-lactel-blue hover:bg-lactel-blue/80 text-white':
        variant === 'secondary' && user?.current_mechanic === 'lactel',
      'bg-topchef text-galbani hover:bg-topchef/80':
        variant === 'topchef' && user?.current_mechanic === 'galbani',
      'bg-lactel-yellow text-lactel-blue hover:bg-lactel-yellow/80':
        variant === 'topchef' && user?.current_mechanic === 'lactel',
      'border border-white bg-transparent text-white': variant === 'outline',
    }"
  >
    <slot />
  </button>
</template>
